<template>
    <div class="email-client-trigger">
        <a class="email-client-trigger__link" :href="getEmailHrefString" @click="clickedEmailLinkEvent">{{email}}</a>
        <Modal v-if="showConfirmModal" @modal:cancel="cancelEvent">
            <template #header-title>{{ $t('header') }}</template>
            <template #body>
                <p>{{ $t('body1') }}</p>
                <p>{{ $t('body2') }}</p>
                <p>{{getEmailString}}</p>
            </template>
            <template #footer-other>
                <Button class="btn-primary" @click="copyToClipboardEvent">{{$t('html.labels.copyToClipboard')}}</Button>
                <Button class="btn-primary" @click="confirmEvent">{{$t('html.forms.yes')}}</Button>
            </template>
        </Modal>
    </div>
</template>

<script>
import Modal from "./Modal.vue";
import Button from "./buttons/Button.vue";

export default {
    components: {Button, Modal},
    props: {
        email: {
            required: true,
            type: String
        },

        name: {
            required: false,
            type: String,
            default: null
        }
    },

    i18n: {
        messages: {
            en: {
                header: 'Would you like to open your mail client?',
                body1: 'Selecting yes will open your mail client if has the necessary permissions.',
                body2: 'Otherwise you can copy it into the clipboard.'
            },
            hu: {
                header: 'Szeretné megnyitni a levelező kliensét?',
                body1: 'Az igen gombra kattintással megnyithatja a levelő kliensét, ha a böngészője rendelkezik a megfelelő jogosultságokkal hozzá.',
                body2: 'Egyéb esetben a vágólapra is másolhatja.'
            }
        }
    },

    data() {return {
        showConfirmModal: false
    };},

    methods: {
        clickedEmailLinkEvent(event) {
            event.preventDefault();
            this.showConfirmModal = true;
        },

        cancelEvent() {
            this.showConfirmModal = false;
        },

        confirmEvent() {
            window.location.href = this.getEmailHrefString;
            this.showConfirmModal = false;
        },

        copyToClipboardEvent() {
            navigator.clipboard.writeText(this.getEmailString).then(
                // Success
                () => {
                    // Do nothing particular
                },
                // Failure
                () => {
                    console.error('Unable to inject data into the clipboard.');
                }
            );

            // as known as "Finally"
            this.showConfirmModal = false;
        }
    },

    computed: {
        getEmailHrefString() {
            return 'mailto:' + this.getEmailString;
        },

        getEmailString() {
            return this.name ?
                `${this.name}<${this.email}>` :
                this.email;
        },
    }
}
</script>
